module.exports = __webpack_public_path__ + "static/media/jak-yak.3e97379e.jpg";